module.exports = __webpack_public_path__ + "static/architectural-comingsoon-767x431-f44f6ad1cea8ec3ba3dcd941cabc31dc.jpg";